import React, { FC } from 'react'
import { format } from 'date-fns'
import { Paper } from '@mui/material'
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium'
import { NetworkOutageItem } from 'src/api'
import { NetworkOutageDownloadLink } from './networkOutageDownloadLink'

const columns: GridColDef<NetworkOutageItem>[] = [
  {
    field: 'datetime',
    headerName: 'Datetime',
    flex: 1,
    minWidth: 180,
    valueFormatter: ({ value }) => (value ? format(new Date(value as string), 'PPpp') : '-')
  },
  {
    field: 'expectedCount',
    headerName: 'Supposed to send',
    flex: 1,
    minWidth: 130
  },
  {
    field: 'actualCount',
    headerName: 'Working right now',
    flex: 1,
    minWidth: 130
  },
  {
    field: 'brokenCount',
    headerName: 'Broken',
    flex: 1,
    minWidth: 130
  },
  {
    field: 'brokenInUseCount',
    headerName: 'Broken in use',
    flex: 1,
    minWidth: 130
  },
  {
    field: 'fileName',
    headerName: 'Broken devices list',
    flex: 1,
    minWidth: 150,
    sortable: false,
    disableColumnMenu: true,
    valueGetter: ({ row }) => (row.fileName ? 'CSV' : '-'),
    renderCell: ({ row }) => (row.fileName && row.id != null ? <NetworkOutageDownloadLink outageId={row.id}>Download CSV</NetworkOutageDownloadLink> : '-')
  }
]

interface NetworkOutagesTableProps {
  rows: NetworkOutageItem[]
  isLoading?: boolean
}

export const NetworkOutagesTable: FC<NetworkOutagesTableProps> = ({ rows, isLoading = false }) => {
  return (
    <Paper sx={{ width: '100%' }}>
      <DataGridPremium<NetworkOutageItem>
        rows={rows}
        columns={columns}
        loading={isLoading}
        getRowId={(row) => row.id ?? (row.datetime as string)}
        autoHeight
        pagination={false}
        hideFooterPagination
        disableRowSelectionOnClick
        rowThreshold={2}
        columnThreshold={2}
        localeText={{ columnMenuSortAsc: 'Sort A-Z', columnMenuSortDesc: 'Sort Z-A', noRowsLabel: 'No network outages detected in this period' }}
        sx={{
          border: 'none',
          '& .MuiDataGrid-columnHeaderTitleContainerContent': { paddingLeft: '5px', overflow: 'visible' },
          '& .MuiDataGrid-columnHeaderTitle': {
            whiteSpace: 'normal',
            lineHeight: 1,
            fontSize: '13px',
            fontWeight: 400,
            color: 'rgba(0, 0, 0, 0.6)',
            overflow: 'visible'
          }
        }}
      />
    </Paper>
  )
}
